export const ALCOHOL_AGE_VERIFIED_KEY = 'alcoholAgeVerified';
export const RECENT_SEARCHES_KEY = 'recentSearches';

export const LOCAL_STORAGE_KEYS = [
  ALCOHOL_AGE_VERIFIED_KEY,
  RECENT_SEARCHES_KEY,
] as const;
